/* eslint-disable no-use-before-define */
import { cleanObject, arrayFrom, formatDate, } from '../../twd'

export default (values) => {
    let p = Object.assign({
        holdRatingAndOr: 'OR',
        holdUnderlyingRating: 'NO',
    }, values)

    delete p.isEdit
    delete p.primarySecondary

    if ((!p.holdCusip && p.cusip) || p.isSubmit) {
        p.holdCusip = (p.cusip || '').split(',').map(a => a.trim()).filter(Boolean)
    }
    if ((!p.holdIssue && p.issuer) || p.isSubmit) {
        p.holdIssue = arrayFrom((p.issuer || '').trim()).filter(Boolean)
    }
    delete p.isSubmit

    p.holdSymbol = arrayFrom(p.holdSymbol).filter(Boolean)
    p.ytwMin = p.offerYtwMin
    p.ytwMax = p.offerYtwMax
    p.ytmMin = p.offerYtmMin
    p.ytmMax = p.offerYtmMax

    let invTypes = arrayFrom(p.holdInvType).filter(Boolean)
    let fieldArrays = Object.keys(getFieldArrays(invTypes))

    ALL_FIELD_ARRAYS.forEach(k => {
        if (fieldArrays.indexOf(k)>=0) return
        delete p[k]
    })

    fieldArrays.forEach(k => {
        let arr = p[k]
        let v = collectFieldArray(arr)
        Object.assign(p, v)
        delete p[k]
    })


    let isCD = invTypes.indexOf('S')>=0
    let isCorp = invTypes.indexOf('C')>=0
    let isTreasury = invTypes.indexOf('T')>=0
    let isMuni = invTypes.indexOf('M')>=0

    p.offeringType = ['ask-side']
    if (isCD || isCorp) {
        p.offeringType = p.offeringType
            .concat(arrayFrom(p.primarySecondary))
            .filter(Boolean)
    }

    if (['AND','OR'].indexOf(p.holdRatingAndOr)<0) {
        p.holdRatingAndOr = p.holdRatingAndOr===true ? 'OR' : 'AND'
    }

    if (isCD || isTreasury) {
        p.holdFdicNum = p.cdFdic
        delete p.holdMoodyRatingMin
        delete p.holdMoodyRatingMax
        delete p.holdSpRatingMin
        delete p.holdSpRatingMax
        delete p.holdRatingAndOr
        delete p.holdUnderlyingRating
    }

    if (isCD) {
        p.holdBlueSkyStateCD = arrayFrom(p.holdBlueSkyStateCD).filter(Boolean)
    }

    if (isMuni) {
        p.holdState = arrayFrom(p.holdState).filter(Boolean)
        p.holdInsurance = p.muniInsured ? ['Any'] : []
    }

    if (p.offeringPosted) {
        p.offeringNewToday = p.offeringPosted==='New today'
        delete p.offeringPosted
    }

    if (p.sortBy) {
        p.sort = [{
            field:p.sortBy,
            direction:SORT_ORDERS[p.sortOrder] || 'ASC'
        }]
        delete p.sortBy
        delete p.sortOrder
    }

    p.holdMaturityMin = formatDate(p.holdMaturityMin)
    p.holdMaturityMax = formatDate(p.holdMaturityMax, true)
    p.holdFirstCallMin = formatDate(p.holdFirstCallMin)
    p.holdFirstCallMax = formatDate(p.holdFirstCallMax, true)

    return cleanObject(p)
}

const getFieldArrays = (invTypes=[]) => {
    return ['_'].concat(invTypes)
        .map(a => FIELD_ARRAYS[a])
        .reduce( (x, a) => {
            return Object.assign({}, x, a)
        })
}

const SORT_ORDERS = {
    'Ascending': 'ASC',
    'Descending': 'DESC'
}

const FIELD_ARRAYS = {
    C: {
        corpSectors: [],
        corpFeatures: [],
        corpDebtRanks: [],
        corpMarketTypes: [],
    },

    M: {
        muniStates: [],
        muniCategories: [],
        muniTaxTreatments: [],
        muniPurposes: [],
        muniEnvironmentals: [],
        muniDeminimis: [],
    },

    S: {
        cdBlueSky: [],
        cdMarketTypes: [],
    },

    T: {
        treasuryTypes: [],
    },

    A: {
        agencyTypes: [],
    },

    _: {
        couponFrequencies: [],
        couponPayMonths: [],
        couponFeatures: [],

        callFeatures: [],
        putFeatures: [],
        otherFeatures: []
    }
}

const ALL_FIELD_ARRAYS = Object.keys(FIELD_ARRAYS)
    .map(a => Object.keys(FIELD_ARRAYS[a]))
    .reduce( (x,a) => (x || []).concat(a))

const collectFieldArray = (array) => (
    arrayFrom(array).reduce( (p, a) => {
        let [k,v] = a.split('=')
        if (!p[k]) p[k] = []

        let arr = p[k]
        let i = arr.indexOf(v)
        if (i<0) arr.push(v)

        return p
    }, {})
)